import { useNavigate } from "react-router-dom";

export function TalentRegSelect() {
    let navigate = useNavigate();

    // 카테고리 데이터 구성 (기존 논의된 명칭 적용)
    const plans = [
        {
            title: "베이직 스타터",
            price: "0원",
            subtitle: "무료 서비스",
            features: ["회원가입 후 등록 가능", "목록 하단 위치"],
            buttonText: "무료 등록하기",
            isPopular: false,
            url: "/talent_reg_mypage"
        },
        {
            title: "라이프 서포트", // 단순노동 카테고리
            price: "20,000원",
            subtitle: "가벼운 도움",
            features: ["이삿짐, 청소, 간단한 심부름 대행", "프리미엄 목록 상단 노출"],
            buttonText: "서포트 등록하기",
            isPopular: true,
            url: "/talent_reg_mypage"
        },
        {
            title: "마스터 클래스", // 전문기술 카테고리
            price: "60,000원",
            subtitle: "전문 역량",
            features: ["악기 레슨, 통번역, 퍼스널 트레이닝", "프리미엄 목록 상단 노출"],
            buttonText: "프로 등록하기",
            isPopular: true, // 강조 효과
            url: "/talent_reg_mypage"
        },
        {
            title: "엑스퍼트 어드바이저", // 비즈니스 카테고리
            price: "100,000원",
            subtitle: "지식 솔루션",
            features: ["이민, 법률, 세무, 커리어 컨설팅", "프리미엄 목록 상단 노출"],
            buttonText: "엑스퍼트 등록하기",
            isPopular: true,
            url: "/talent_reg_mypage"
        }
    ];

    return (
        <div>
            <main className="page landing-page">
                <section className="py-4 py-xl-5">
                    <div className="container py-4 py-xl-5" style={{ paddingTop: '100px', marginTop: '50px', marginBottom: '10px' }}>
                        <div className="row mb-5">
                            <div className="col-md-8 col-xl-6 text-center mx-auto">
                                <h3 style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>서비스 등록 유형 선택</h3>
                                <p className="text-muted">제공하시는 재능의 성격에 맞는 카테고리를 선택해 주세요.</p>
                            </div>
                        </div>

                        {/* 카드 레이아웃: 4개일 경우 xl-4 또는 row-cols-xl-4가 적당합니다 */}
                        <div className="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-4 d-xl-flex align-items-xl-stretch">
                            {plans.map((plan, index) => (
                                <div className="col" key={index}>
                                    <div className={`card h-100 ${plan.isPopular ? 'border-primary border-2' : ''}`}>
                                        <div className="card-body text-center p-4">
                                            <h6 className="text-uppercase text-muted card-subtitle" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '18px' }}>
                                                {plan.subtitle}
                                            </h6>
                                            <h4 className="fw-bold card-title" style={{ fontSize: '30px', marginTop: '10px' }}>
                                                <strong>{plan.title}</strong>
                                            </h4>
                                            <h5 className="display-6 fw-bold text-primary">{plan.price}</h5>
                                        </div>
                                        <div className="card-footer p-4 bg-transparent border-0">
                                            <ul className="list-unstyled">
                                                {plan.features.map((feature, i) => (
                                                    <li className="d-flex mb-2" key={i}>
                                                        <span className="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-check-lg">
                                                                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022"></path>
                                                            </svg>
                                                        </span>
                                                        <span style={{ fontSize: '14px' }}>{feature}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                            <button 
                                                className={`btn ${plan.isPopular ? 'btn-primary' : 'btn-outline-primary'} d-block w-100`} 
                                                onClick={() => navigate(plan.url)}
                                                style={{ fontWeight: 'bold' }}
                                            >
                                                {plan.buttonText}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}